export default __webpack_public_path__ + "static/media/complementary--go-right--g1.f0fa8d37.png";